import React, { useEffect, useState } from "react";
import {
  Button,
  CircularProgress,
  FormControl,
  InputLabel,
  MenuItem,
  Grid,
  Select,
  Tabs,
  Tab,
  TablePagination,
  Table,
  TableContainer,
  TableRow,
  TableCell,
  TableHead,
  TableBody,
} from "@mui/material";
import MuiHeader from "../../components/MuiHeader";
import { toast, ToastContainer } from "react-toastify";
import * as XLSX from "xlsx";
import apiPrakasak from "../../api/apiPrakasak";
import moment from "moment/moment";

const PrakashakDistrict = () => {
  const [districts, setDistricts] = useState([]);
  const [selectedDistrict, setSelectedDistrict] = useState("");
  const [selectedDistricts, setSelectedDistricts] = useState("");
  const [selectedData, setSelectedData] = useState([]);
  const [year, setYear] = useState("");
  const [month, setMonth] = useState("");
  const [perfKey, setPerfKey] = useState("");
  const [file, setFile] = useState(null);
  const [excelData, setExcelData] = useState([]);
  console.log("excelData", excelData);
  const [isDraggedOver, setIsDraggedOver] = useState(false);
  const [loadingSave, setLoadingSave] = useState(false);
  const [loadingDistricts, setLoadingDistricts] = useState(false);
  const [tabValue, setTabValue] = useState(0);
  const [overallData, setOverallData] = useState([]);
  const [loadingData, setLoadingData] = useState(false);
  const currentYear = new Date().getFullYear();
  const currentMonth = new Date().getMonth() + 1;
  const [topPerformersData, setTopPerformersData] = useState({
    top_clusters: [],
    top_schools: [],
    low_clusters: [],
    low_schools: [],
    lastUpdated: "",
  });
  const years = ["2025"];
  const months = [
    { value: 1, label: "January" },
    { value: 2, label: "February" },
    { value: 3, label: "March" },
    { value: 4, label: "April" },
    { value: 5, label: "May" },
    { value: 6, label: "June" },
    { value: 7, label: "July" },
    { value: 8, label: "August" },
    { value: 9, label: "September" },
    { value: 10, label: "October" },
    { value: 11, label: "November" },
    { value: 12, label: "December" },
  ];
  // const allFieldsSelected =
  const perfKeys = [
    { key: "top_clusters", label: "Top Clusters" },
    { key: "top_schools", label: "Top Schools" },
    { key: "low_clusters", label: "Low Clusters" },
    { key: "low_schools", label: "Low Schools" },
  ];

  useEffect(() => {
    if (parseInt(year) === currentYear && parseInt(month) > currentMonth) {
      alert("The selected month cannot be in the future for the current year.");
      setMonth("");
    }
  }, [month, year, currentYear, currentMonth]);

  useEffect(() => {
    const fetchDistricts = async () => {
      setLoadingDistricts(true);
      try {
        const response = await apiPrakasak.get("getAllDistricts");
        if (response?.data) {
          setDistricts(response.data.map((item) => item.district));
        }
      } catch (error) {
        toast.error("Failed to fetch districts.");
      } finally {
        setLoadingDistricts(false);
      }
    };
    fetchDistricts();
  }, []);

  const handleDistrictChange = (event) => {
    setSelectedDistrict(event.target.value);
    setFile(null);
    setExcelData([]);
    // fetchTopPerformance();
  };

  const handleDistrictsChange = (event) => {
    setSelectedDistricts(event.target.value);
    setFile(null);
    setExcelData([]);
    // fetchTopPerformance();
  };

  const handleDatachange = (event) => {
    setSelectedData(event?.target?.value);
    setFile(null);
    setExcelData([]);
    if (event?.target?.value === "performance") {
      fetchMonthlyPerformanceDetails();
    } else {
      fetchMonthlyPerformanceTimespentDetails();
    }
  };

  const handleTabChange = (event, newValue) => {
    setTabValue(newValue);
    setSelectedDistrict("");
    setSelectedDistricts("");
    setSelectedData([]);
    setYear("");
    setMonth("");
    setPerfKey("");
    setFile(null);
    setExcelData([]);
    setOverallData([]);
    setTopPerformersData({
      top_clusters: [],
      top_schools: [],
      low_clusters: [],
      low_schools: [],
      lastUpdated: "",
    });
  };
  const resetForm = () => {
    // setSelectedDistrict("");
    setYear("");
    setMonth("");
    setPerfKey("");
    setFile(null);
    setExcelData([]);
    setOverallData([]);
    setTopPerformersData({
      top_clusters: [],
      top_schools: [],
      low_clusters: [],
      low_schools: [],
      lastUpdated: "",
    });
  };
  const handleDragOver = (e) => {
    e.preventDefault();
    setIsDraggedOver(true);
  };

  const handleDragLeave = () => {
    setIsDraggedOver(false);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    setIsDraggedOver(false);
    const droppedFile = e.dataTransfer.files[0];
    if (isValidExcelFile(droppedFile)) {
      processExcelFile(droppedFile);
      setFile(droppedFile);
      toast.success("File uploaded successfully!");
    } else {
      toast.error("Please upload a valid Excel file (.xlsx)");
    }
  };

  const handleFileInputChange = (e) => {
    const uploadedFile = e.target.files[0];
    if (isValidExcelFile(uploadedFile)) {
      processExcelFile(uploadedFile);
      setFile(uploadedFile);
      toast.success("File uploaded successfully!");
    } else {
      toast.error("Please upload a valid Excel file (.xlsx)");
    }
  };

  const isValidExcelFile = (file) =>
    file &&
    file.type ===
      "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet";

  const processExcelFile = (file) => {
    const reader = new FileReader();
    reader.onload = (event) => {
      const data = new Uint8Array(event.target.result);
      const workbook = XLSX.read(data, { type: "array" });
      const sheetName = workbook.SheetNames[0];
      const sheet = workbook.Sheets[sheetName];
      const jsonData = XLSX.utils.sheet_to_json(sheet, { defval: "" });

      const isValid = validateExcelHeaders(jsonData);
      if (isValid) {
        setExcelData(jsonData);
      } else {
        setFile(null);
        setExcelData([]);
        toast.error("Excel headers do not match the expected format.");
      }
    };
    reader.readAsArrayBuffer(file);
  };

  const validateExcelHeaders = (jsonData) => {
    const headersOverall = [
      "total_blocks",
      "total_clusters",
      "total_students",
      "class1_students",
      "class2_students",
      "class3_students",
      "class4_students",
      "class5_students",
      "total_boys",
      "total_girls",
      "smartphone_users",
      "non_smartphone_users",
      "lastUpdated",
    ];

    const headersTopPerformers =
      perfKey === "top_clusters" || perfKey === "low_clusters"
        ? ["block", "cluster"]
        : ["school_name", "block", "cluster"];

    const headers = tabValue === 0 ? headersOverall : headersTopPerformers;
    const actualHeaders = Object.keys(jsonData[0]);
    return headers.every((header) => actualHeaders.includes(header));
  };

  const validateSubmission = () => {
    if (tabValue === 0 && (!selectedDistrict || !file || !excelData.length)) {
      toast.error("Please select a district and upload a valid Excel file.");
      return false;
    }
    if (
      tabValue === 1 &&
      (!selectedDistricts || !selectedData || !file || !excelData.length)
    ) {
      toast.error("Please select a districts and upload a valid Excel file.");
      return false;
    }
    if (
      tabValue === 2 &&
      (!selectedDistricts ||
        !file ||
        !excelData.length ||
        !year ||
        !month ||
        !perfKey)
    ) {
      toast.error("Please complete all fields for Top Performers.");
      return false;
    }
    return true;
  };

  // useEffect(() => {
  //   if (tabValue === 0 && selectedDistrict) {
  //     fetchOverallDetails();
  //   } else if (tabValue === 2 && selectedDistrict && year && month && perfKey) {
  //     fetchTopPerformance();
  //   }
  // }, [tabValue, selectedDistrict, year, month, perfKey]);

  const fetchOverallDetails = async () => {
    setLoadingData(true);
    try {
      const response = await apiPrakasak.get(
        `/getOverallDetails/${selectedDistrict}`
      );
      if (response?.data) setOverallData(response.data);
      toast.success("Overall data fetched successfully!");
    } catch (error) {
      toast.error("Error fetching overall data.");
    } finally {
      setLoadingData(false);
    }
  };

  const fetchMonthlyPerformanceDetails = async () => {
    setLoadingData(true);
    const body = {
      district: selectedDistricts,
    };
    try {
      const response = await apiPrakasak.post(`/getMonthlyPerformance`, body);
      console.log("response data---------->", response);
      if (response?.data) {
        setOverallData(response.data.data);
      }
      toast.success("Overall data fetched successfully!");
    } catch (error) {
      toast.error("Error fetching overall data.");
    } finally {
      setLoadingData(false);
    }
  };

  // console.log("Overall Data fetched---------->", overallData);
  const fetchMonthlyPerformanceTimespentDetails = async () => {
    setLoadingData(true);
    const body = {
      district: selectedDistricts,
    };
    try {
      const response = await apiPrakasak.post(`/getMonthlyPerfTimespent`, body);
      console.log("response data---------->", response);
      if (response?.data) {
        setOverallData(response?.data?.data);
      }
      toast.success("Overall data fetched successfully!");
    } catch (error) {
      toast.error("Error fetching overall data.");
    } finally {
      setLoadingData(false);
    }
  };

  const fetchTopPerformance = async () => {
    setLoadingData(true);
    try {
      const response = await apiPrakasak.get(
        `/getPerformance/${selectedDistricts}/${perfKey}/${year}/${month}`
      );
      if (response?.data) setTopPerformersData(response.data);
      // toast.success("Top Performers data fetched successfully!");
    } catch (error) {
      toast.error("Error fetching top performers data.");
    } finally {
      setLoadingData(false);
    }
  };

  console.log("month--------------->", month);

  const handlePerfKeyChange = async (key) => {
    setPerfKey(key);
    setLoadingData(true);

    try {
      // Simulate API call
      const response = await apiPrakasak.get(
        `/getPerformance/${selectedDistricts}/${key}/${year}/${month}`
      );
      if (response?.data)
        setTopPerformersData({
          top_clusters: response?.data?.top_clusters || [],
          top_schools: response?.data?.top_schools || [],
          low_clusters: response?.data?.low_clusters || [],
          low_schools: response?.data?.low_schools || [],
          lastUpdated: response?.data?.lastUpdated || "",
        });
    } catch (error) {
      console.error("Error fetching performance data:", error);
    } finally {
      setLoadingData(false);
    }
  };

  const submit = async () => {
    if (!validateSubmission()) return;
    setLoadingSave(true);

    try {
      if (tabValue === 0) {
        const overallData = excelData.map((row) => ({
          district: selectedDistrict,
          ...row,
        }));
        await apiPrakasak.post("/saveOverallDetails", overallData);
        toast.success("Data submitted successfully to Overall Dashboard!");
        resetForm();
        fetchOverallDetails();
      } else if (tabValue === 1) {
        if (selectedData === "performance") {
          const overallData = excelData.map((row) => {
            const { lastUpdated, ...rest } = row;
            const sanitizedLastUpdated =
              typeof lastUpdated === "string" && lastUpdated.startsWith('"')
                ? JSON.parse(lastUpdated)
                : lastUpdated;
            return {
              ...rest,
              lastUpdated: sanitizedLastUpdated,
            };
          });
          // console.log("overallData", overallData);
          await apiPrakasak.post("/saveMonthlyPerformance", overallData);
          toast.success("Data submitted successfully to Overall Dashboard!");
          resetForm();
          fetchMonthlyPerformanceDetails();
        } else {
          const overallData = excelData.map((row) => {
            const { lastUpdated, ...rest } = row;
            const sanitizedLastUpdated =
              typeof lastUpdated === "string" && lastUpdated.startsWith('"')
                ? JSON.parse(lastUpdated)
                : lastUpdated;
            return {
              ...rest,
              lastUpdated: sanitizedLastUpdated,
            };
          });
          // console.log("abcd", overallData);
          await apiPrakasak.post("/saveMonthlyPerfTimespent", overallData);
          toast.success("Data submitted successfully to Overall Dashboard!");
          resetForm();
          fetchMonthlyPerformanceTimespentDetails();
        }
      } else {
        const topPerformanceData = {
          district: selectedDistricts,
          year,
          month: parseInt(month),
          perfKey,
          [perfKey]: excelData,
        };
        await apiPrakasak.post("/savePerformance", topPerformanceData);
        toast.success("Data submitted successfully to Top Performers!");
        resetForm();
        fetchTopPerformance();
      }
    } catch (error) {
      resetForm();
      toast.error("Error submitting data. Please try again.");
    } finally {
      setLoadingSave(false);
    }
  };

  return (
    <div>
      <MuiHeader header="District-wise PRAKASHAK Static data" />

      <Tabs
        value={tabValue}
        onChange={handleTabChange}
        style={{ width: "100%" }}
      >
        <Tab label="Overall Dashboard" />
        <Tab label="Monthly Performance" />
        <Tab label="Overall Performers" />
      </Tabs>

      <Grid container spacing={2} sx={{ marginTop: 2 }}>
        {tabValue === 0 ? (
          <Grid item xs={12} sm={6} md={3}>
            <FormControl fullWidth>
              <InputLabel id="district-label">District</InputLabel>
              <Select
                labelId="district-label"
                value={selectedDistrict}
                onChange={handleDistrictChange}
                label="District"
              >
                {loadingDistricts ? (
                  <MenuItem disabled>Loading...</MenuItem>
                ) : (
                  districts.map((district, index) => (
                    <MenuItem key={index} value={district}>
                      {district}
                    </MenuItem>
                  ))
                )}
              </Select>
            </FormControl>
          </Grid>
        ) : null}
        {tabValue === 1 ? (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="districts-label">District</InputLabel>
                <Select
                  labelId="districts-label"
                  value={selectedDistricts}
                  onChange={handleDistrictsChange}
                  label="Districts"
                >
                  {loadingDistricts ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : (
                    districts.map((districtss, index) => (
                      <MenuItem key={index} value={districtss}>
                        {districtss}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="Graph-data">Choose Data</InputLabel>
                <Select
                  labelId="selected Graph"
                  value={selectedData}
                  onChange={handleDatachange}
                  label="Data"
                >
                  {["performance", "timespent"].map((graph, index) => (
                    <MenuItem key={index} value={graph}>
                      {graph}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        ) : null}
        {tabValue === 2 ? (
          <>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="districts-label">District</InputLabel>
                <Select
                  labelId="districts-label"
                  value={selectedDistricts}
                  onChange={handleDistrictsChange}
                  label="Districts"
                >
                  {loadingDistricts ? (
                    <MenuItem disabled>Loading...</MenuItem>
                  ) : (
                    districts.map((districtss, index) => (
                      <MenuItem key={index} value={districtss}>
                        {districtss}
                      </MenuItem>
                    ))
                  )}
                </Select>
              </FormControl>
            </Grid>
            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="year-label">Year</InputLabel>
                <Select
                  labelId="year-label"
                  value={year}
                  onChange={(e) => setYear(e.target.value)}
                  label="Year"
                >
                  {selectedDistricts && selectedDistricts.length > 0
                    ? years.map((yearValue, index) => (
                        <MenuItem key={index} value={yearValue}>
                          {yearValue}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="month-label">Month</InputLabel>
                <Select
                  labelId="month-label"
                  value={month}
                  onChange={(e) => setMonth(e.target.value)}
                  label="Month"
                >
                  {year && year.length > 0
                    ? months.map((monthValue, index) => (
                        <MenuItem key={index} value={monthValue.value}>
                          {monthValue.label}
                        </MenuItem>
                      ))
                    : null}
                </Select>
              </FormControl>
            </Grid>

            <Grid item xs={12} sm={6} md={3}>
              <FormControl fullWidth>
                <InputLabel id="perfKey-label">Top Performance Key</InputLabel>
                <Select
                  labelId="perfKey-label"
                  value={perfKey}
                  onChange={(e) => handlePerfKeyChange(e.target.value)}
                  label="Top Performance Key"
                >
                  {perfKeys.map((keyOption, index) => (
                    <MenuItem key={index} value={keyOption.key}>
                      {keyOption.label}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </Grid>
          </>
        ) : null}
      </Grid>
      {(selectedDistricts && selectedDistricts.length > 0) ||
      (selectedDistrict && selectedDistrict.length > 0) ? (
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            width: "50%",
            border: "2px dashed #007bff",
            padding: "20px",
            textAlign: "center",
            backgroundColor: isDraggedOver ? "#e3f2fd" : "transparent",
            marginTop: "20px",
          }}
        >
          <p style={{ fontSize: "1.3rem" }}>
            {isDraggedOver
              ? "Drop the Excel file here..."
              : file
              ? `File uploaded: ${file.name}`
              : "Drag and drop an Excel file or click to upload"}
          </p>
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFileInputChange}
            style={{ display: "none" }}
            id="fileUpload"
          />
          {!file && (
            <label htmlFor="fileUpload">
              <Button variant="contained" component="span">
                Upload File
              </Button>
            </label>
          )}
          {file && (
            <Button
              variant="contained"
              color="primary"
              onClick={submit}
              disabled={loadingSave}
              style={{ marginTop: "20%", width: "20%" }}
            >
              {loadingSave ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          )}
        </div>
      ) : selectedData.length > 0 ? (
        <div
          onDragOver={handleDragOver}
          onDragLeave={handleDragLeave}
          onDrop={handleDrop}
          style={{
            width: "50%",
            border: "2px dashed #007bff",
            padding: "20px",
            textAlign: "center",
            backgroundColor: isDraggedOver ? "#e3f2fd" : "transparent",
            marginTop: "20px",
          }}
        >
          <p style={{ fontSize: "1.3rem" }}>
            {isDraggedOver
              ? "Drop the Excel file here..."
              : file
              ? `File uploaded: ${file.name}`
              : "Drag and drop an Excel file or click to upload"}
          </p>
          <input
            type="file"
            accept=".xlsx"
            onChange={handleFileInputChange}
            style={{ display: "none" }}
            id="fileUpload"
          />
          {!file && (
            <label htmlFor="fileUpload">
              <Button variant="contained" component="span">
                Upload File
              </Button>
            </label>
          )}
          {file && (
            <Button
              variant="contained"
              color="primary"
              onClick={submit}
              disabled={loadingSave}
              style={{ marginTop: "20%", width: "20%" }}
            >
              {loadingSave ? (
                <CircularProgress size={24} color="inherit" />
              ) : (
                "Submit"
              )}
            </Button>
          )}
        </div>
      ) : null}
      <div style={{ marginTop: "15%", width: "100%" }}>
        {tabValue === 0 && (
          <div style={{ padding: "20px", overflowX: "auto" }}>
            {/* Display Overall Data */}
            {loadingData ? (
              <CircularProgress />
            ) : overallData.length === 0 ? (
              <p
                style={{ textAlign: "center", fontSize: "20px", color: "red" }}
              >
                No records found
              </p>
            ) : (
              <>
                {}
                <table style={{ width: "100%", borderCollapse: "collapse" }}>
                  <thead>
                    <tr style={{ backgroundColor: "#f2f2f2" }}>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        District
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Total Blocks
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Total Clusters
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Total Students
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Class 1 Students
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Class 2 Students
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Class 3 Students
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Class 4 Students
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Class 5 Students
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Total Boys
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Total Girls
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Smartphone Users
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Non-Smartphone Users
                      </th>
                      <th
                        style={{
                          padding: "10px",
                          border: "1px solid #ddd",
                          textAlign: "left",
                        }}
                      >
                        Last Updated
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    {overallData.map((data, index) => (
                      <tr
                        key={index}
                        style={{ "&:hover": { backgroundColor: "#f5f5f5" } }}
                      >
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.district}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.total_blocks}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.total_clusters}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.total_students}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.class1_students}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.class2_students}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.class3_students}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.class4_students}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.class5_students}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.total_boys}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.total_girls}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.smartphone_users}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {data.non_smartphone_users}
                        </td>
                        <td
                          style={{
                            padding: "10px",
                            border: "1px solid #ddd",
                            textAlign: "left",
                          }}
                        >
                          {new Date(data.lastUpdated).toLocaleString()}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </>
            )}
          </div>
        )}

        {tabValue === 1 && (
          <div style={{ padding: "20px", overflowX: "auto" }}>
            {loadingData ? (
              <CircularProgress />
            ) : !loadingData && overallData.length === 0 ? (
              <p
                style={{ textAlign: "center", fontSize: "20px", color: "red" }}
              >
                No records found
              </p>
            ) : !loadingData && overallData ? (
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>Sl no.</TableCell>
                    <TableCell>District</TableCell>
                    <TableCell>Block</TableCell>
                    <TableCell>Cluster</TableCell>
                    <TableCell>School</TableCell>
                    {selectedData === "timespent" ? (
                      <TableCell>year</TableCell>
                    ) : null}
                    {selectedData === "timespent" ? (
                      <TableCell>month</TableCell>
                    ) : null}
                    {selectedData === "performance" ? (
                      <TableCell>Registered Students</TableCell>
                    ) : null}
                    {selectedData === "performance" ? (
                      <TableCell>Active Students</TableCell>
                    ) : null}
                    <TableCell>{"<"} 30 mins</TableCell>
                    <TableCell>30mins - 1hr</TableCell>
                    <TableCell>1-2 hr</TableCell>
                    <TableCell>2-3 hr</TableCell>
                    <TableCell>{">"} 3hr</TableCell>
                    <TableCell>Last Updated</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {overallData?.map((item, index) => (
                    <>
                      <TableRow>
                        <TableCell>{index + 1}</TableCell>
                        <TableCell>{item.district}</TableCell>
                        <TableCell>{item.block}</TableCell>
                        <TableCell>{item.cluster}</TableCell>
                        <TableCell>{item.school_name}</TableCell>
                        {selectedData === "timespent" ? (
                          <TableCell>{item.year}</TableCell>
                        ) : null}
                        {selectedData === "timespent" ? (
                          <TableCell>{item.month}</TableCell>
                        ) : null}
                        {selectedData === "performance" ? (
                          <TableCell>{item.registeredStudents}</TableCell>
                        ) : null}
                        {selectedData === "performance" ? (
                          <TableCell>{item.activeStudents}</TableCell>
                        ) : null}
                        <TableCell>{item.users_lt_30min}</TableCell>
                        <TableCell>{item.users_30min_to_1hr}</TableCell>
                        <TableCell>{item.users_1to2hr}</TableCell>
                        <TableCell>{item.users_2to3hr}</TableCell>
                        <TableCell>{item.users_gt_3hr}</TableCell>
                        <TableCell>
                          {moment(item.lastUpdated).format("DD-MM-YYYY")}
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            ) : null}
          </div>
        )}

        {tabValue === 2 && (
          <div style={{ padding: "20px", overflowX: "auto" }}>
            {loadingData ? (
              <CircularProgress />
            ) : (
              <>
                {year && month && perfKey && selectedDistricts && (
                  <table style={{ width: "100%", borderCollapse: "collapse" }}>
                    <thead>
                      <tr
                        style={{
                          backgroundColor: "#f2f2f2",
                        }}
                      >
                        {perfKey === "top_schools" ||
                        perfKey === "low_schools" ? (
                          <th
                            style={{
                              padding: "10px",
                              border: "1px solid #ddd",
                            }}
                          >
                            {perfKey === "top_schools"
                              ? "Top Schools"
                              : "Low Schools"}
                          </th>
                        ) : (
                          <th
                            style={{
                              padding: "10px",
                              border: "1px solid #ddd",
                            }}
                          >
                            {perfKey === "top_clusters"
                              ? "Top Clusters"
                              : "Low Clusters"}
                          </th>
                        )}
                        {perfKey === "top_schools" ||
                        perfKey === "low_schools" ? (
                          <th
                            style={{
                              padding: "10px",
                              border: "1px solid #ddd",
                            }}
                          >
                            Clusters
                          </th>
                        ) : null}

                        <th
                          style={{ padding: "10px", border: "1px solid #ddd" }}
                        >
                          Blocks
                        </th>
                        <th
                          style={{ padding: "10px", border: "1px solid #ddd" }}
                        >
                          Last Updated
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {/* Conditional Table Rows */}
                      {(perfKey === "top_clusters" ||
                        perfKey === "low_clusters") &&
                        topPerformersData[perfKey].map((cluster, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {cluster.cluster}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {cluster.block}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {new Date(
                                topPerformersData.lastUpdated
                              ).toLocaleString()}
                            </td>
                          </tr>
                        ))}

                      {(perfKey === "top_schools" ||
                        perfKey === "low_schools") &&
                        topPerformersData[perfKey].map((school, index) => (
                          <tr key={index}>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {school.school_name}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {school.cluster}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {school.block}
                            </td>
                            <td
                              style={{
                                padding: "10px",
                                border: "1px solid #ddd",
                              }}
                            >
                              {new Date(
                                topPerformersData.lastUpdated
                              ).toLocaleString()}
                            </td>
                          </tr>
                        ))}
                    </tbody>
                  </table>
                )}
              </>
            )}
          </div>
        )}
      </div>
      <ToastContainer />
    </div>
  );
};

export default PrakashakDistrict;
